module.exports = __webpack_public_path__ + "img/Group 14.c5bac55a.svg";